import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorPaymentRequestResponse from "./distributorPaymentRequestResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import Approvable from "./approvable";
import type RefundApprovalType from "./refundApprovalType";
import type { IApprovable } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class DistributorRefundResponse extends Approvable implements IApprovable<RefundApprovalType> {
  id!: string;

  @observable
  distributorName!: string;

  @observable
  @Type(() => DistributorPaymentRequestResponse)
  distributorPaymentRequest!: DistributorPaymentRequestResponse;

  @observable
  amount!: number;

  @observable
  variableSymbol!: number;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];
}

export default class DistributorRefund extends DistributorRefundResponse {
  @observable
  isSelectable: boolean;
}
